import React from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { StepLayout } from 'apps/aiTextImprover/components/StepLayout/StepLayout'
import { AiTextImproverAnalytics } from 'apps/aiTextImprover/lib/analytics'
import illustration from 'components/Ai/AiAssistantDecoration/ChatLogo.svg'
import { useDidMountEffect } from 'utils/commonHooks'

import cm from './AddonPromotionStep.module.css'

interface AddonPromotionStepProps {
  onUpgradeSubmit: (upgradeClicked: boolean) => void
}

export const AddonPromotionStep = ({ onUpgradeSubmit }: AddonPromotionStepProps) => {
  useDidMountEffect(() => {
    AiTextImproverAnalytics.logAddonPromotionStepVisible()
  })

  return (
    <StepLayout showWidgetTitle={false}>
      <section className={cm.content}>
        <img
          className={cm.content__illustration}
          src={illustration}
          width={120}
          height={120}
          aria-hidden="true"
        />

        <h1 className={cx('text-heading-2', cm.content__heading)}>
          {l.translate('Improve without limits')}
        </h1>

        <p className={cm.content__description}>
          {l.translate(
            'Unlimited text improvements, Intention Recognition, AI Step and more available\xa0now',
          )}
        </p>

        <div className={cm.content__footer}>
          <BtnV2 onClick={() => onUpgradeSubmit(true)} variant="primary">
            {l.translate('Get Manychat AI')}
          </BtnV2>

          <BtnV2 onClick={() => onUpgradeSubmit(false)} variant="ghost-primary">
            {l.translate('Not now')}
          </BtnV2>
        </div>
      </section>
    </StepLayout>
  )
}
